import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";

import { useHistory } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { EXCHANGE_PRODUCT_REQUEST, DELETE_TARGET_REQUEST } from "containers/starshop/Action";
import img1 from "styles/common/img/common/picon1.png";

const ExchangeDone = (props) => {
    const { phoneNumber, myInfo, targetCode } = props;
    const history = useHistory();
    const dispatch = useDispatch();

    const [modalOpen, setModalOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const exchangeCode = useSelector((state) => state.starshopReducer.exchangeCode);

    useEffect(() => {
        setDisabled(false);
        //목표상품 구매 성공시
        if (exchangeCode === "200") {
            console.log("조건문안 exchangeCode", exchangeCode);
            dispatch(
                DELETE_TARGET_REQUEST({
                    contractNumber: myInfo.contractNumber,
                    customerNumber: myInfo.customerNumber,
                }),
            );
        } else {
            //목표상품 구매 실패시
            setDisabled(true);
        }
    }, [exchangeCode]);

    const handleClick = () => {
        setModalOpen(!modalOpen);
        dispatch(
            EXCHANGE_PRODUCT_REQUEST({
                contractNumber: myInfo.contractNumber,
                customerNumber: myInfo.customerNumber,
                rewardCode: targetCode,
                phoneNumber: phoneNumber.arr1 + phoneNumber.arr2 + phoneNumber.arr3,
                receiver: myInfo.userNm,
            }),
        );
    };

    const handlePage = () => {
        history.replace("/starshop?tab=2");
    };

    return (
        <div className="d-inline-block">
            <div className="pop_btn2 clear">
                <button type="button" className="new2btn newbtn__txt" onClick={handleClick}>
                    확인
                </button>
            </div>
            <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen} className="popopWrap2">
                <div className="pop_icon">
                    <img src={img1} />
                </div>
                <div className="pop_tit"></div>
                <div className="pop_txt">
                    {!disabled ? (
                        <p className="">
                            {phoneNumber.arr1}-{phoneNumber.arr2}-{phoneNumber.arr3}
                            <br />
                            번호로 선물이 발송 되었습니다.
                        </p>
                    ) : (
                        <p className="">
                            발송이 실패하였습니다.
                            <br />
                            다시 교환 신청을 해주세요.
                        </p>
                    )}
                    {/* <p className="">{phoneNumber.arr1}-{phoneNumber.arr2}-{phoneNumber.arr3}<br/>번호로 선물이 발송 되었습니다.</p>
          <p className="d-none">발송이 실패하였습니다.<br/>다시 교환 신청을 해주세요.</p> */}
                </div>
                <div className="pop_btn2 clear">
                    <div type="button" className="new2btn newbtn__txt newbtn__one" onClick={handlePage}>
                        확인
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default React.memo(ExchangeDone);
